import { SortEnum } from "@finway-group/shared/lib/consts"
import { QueryParamsObject } from "@finway-group/shared/lib/models"
import { SortOrder } from "antd/lib/table/interface"

// antd understands "ascend and descend" and back end understands "asc and desc"
export const convertSortingToString = (sorting?: { order: SortOrder | string; field: string }) => {
    if (!sorting?.order || !sorting?.field) {
        return ""
    }
    return `&sortBy=${sorting.order === "ascend" ? "asc" : "desc"}(${sorting.field})`
}

export const getSortQueryObject = (sorting?: { field?: string; order?: SortEnum }): Pick<QueryParamsObject, "sortBy"> => {
    if (!sorting?.order || !sorting?.field) {
        return {}
    }
    return { sortBy: `${sorting.order}(${sorting.field})` }
}
